// types
import { i18nDispatcherProductionPlanning } from 'models/i18n';
import {
  MarketPeriodsType,
  MetricValueType,
  PlanRevisionStatus
} from 'utils/constants';
import { DailyDiagramValidationReason } from 'models/dispatcher';

// ==============================|| I18N SK USERS ||============================== //

const enDispatcherProductionPlanning: i18nDispatcherProductionPlanning = {
  title: 'Production planning',
  csvPrefix: 'BG',
  businessDay: {
    title: 'Business day',
    step01: 'Income deadline',
    step02: 'Evaluation',
    step03: 'Deadline'
  },
  systemValues: {
    title: 'System values',
    [MetricValueType.price15mD1]: 'Predicted price IDM15',
    [MetricValueType.price60mD1]: 'Predicted price IDM60',
    [MetricValueType.priceDamD1]: 'Predicted price DAM',
    [MetricValueType.predictionSystemImbalanceD1]: 'Predicted system imbalance',
    price: '€/MWh',
    imbalance: 'MWh'
  },
  balanceGroupDiagram: {
    title: 'Planned production of balancing group',
    [MetricValueType.energyProdNomination]: 'Nomination',
    [MetricValueType.predProdEnergyProdD1]: 'Predicted nomination',
    [MetricValueType.energyProdSummaryProduction]: 'Production summary',
    [MetricValueType.currentImbalanceD1]: 'Balancing group imbalance',
    [MetricValueType.plannedImbalancePrice]:
      'Predicted price of planned imbalance',
    [MetricValueType.plannedImbalanceD1]: 'Planned imbalance of balancing group'
  },
  productionPlan: {
    productionPlanTitle: 'Production plan',
    consumptionPlanTitle: 'Consumption plan',
    revisionNr: 'Revision ',
    productionPlanPeriodDuration: {
      [MarketPeriodsType.MARKET_PERIODS]: 'Market period',
      [MarketPeriodsType.MARKET_HOURS]: 'Hour'
    },
    changeNominationToSummaryProduction:
      'Change nomination to summary production',
    nomination: 'Nomination',
    productionSummary: 'Production summary',
    revisionHistory: 'Revision History',
    sendToOKTE: 'Send to OKTE',
    showPrediction: 'Show prediction',
    deviceProductionPlan: {
      confirm: 'Confirm',
      edit: 'Edit',
      propagate: 'Propagate',
      showRevisionHistory: 'Show revision history',
      columns: {
        productionPlan: 'Production plan',
        requestedProduction: 'Requested production',
        predictedProduction: 'Predicted production'
      }
    },
    [MetricValueType.predProdEndOfPeriodSocD1]:
      'Prediction of state of charge of the battery at the end of the period',
    [MetricValueType.predProdEndOfPeriodEnergyStoredD1]:
      'Prediction of saved energy',
    [MetricValueType.predProdEndOfPeriodFreeCapacityD1]:
      'Prediction of free capacity',
    [MetricValueType.predProdEnergyProdD1]: 'Prediction of production',
    [MetricValueType.predProdEndOfPeriodPowerD1]:
      'Power at the end of the period'
  },
  productionPlanRevisionStatus: {
    [PlanRevisionStatus.DRAFT]: 'Draft',
    [PlanRevisionStatus.CONFIRMED]: 'Confirmed',
    [PlanRevisionStatus.PROPAGATED]: 'Propagated',
    [PlanRevisionStatus.PLANNED]: 'Planned',
    [PlanRevisionStatus.REJECTED]: 'Rejected',
    [PlanRevisionStatus.NEW]: '-',
    [PlanRevisionStatus.ACCEPTED]: 'Accepted'
  },
  dailyDiagram: {
    createDailyNomination: 'Create daily nomination',
    updateDailyNomination: 'Update daily nomination',
    acceptDailyNomination: 'Accept daily nomination',
    showHistoryOfDailyNomination: 'Show daily nomination history',
    historyOfDailyNomination: 'Daily nomination history'
  },
  revision: {
    revision: 'Revision',
    status: 'Status',
    totalProduction: 'Production summary',
    createdBy: 'Created by',
    createdAt: 'Created at',
    revisionHistory: 'Revision history',
    currentRevision: 'Current',
    copyRevision: 'Copy production plan',
    copyRevisionDescription:
      'Select the date or range of dates in future to which you want to copy the production plan',
    confirmCopy: 'Copy production plan',
    confirmCopyRevision: 'Apply production plan',
    confirmApply:
      'Are you sure you want to create a production plan for the selected days?',
    confirmRevision: 'Confirm production plan',
    confirmConfirm:
      'Are you sure you want to confirm a production plan for device ',
    propagateRevision: 'Propagate production plan',
    confirmPropagate:
      'Are you sure you want to propagate production plan for device '
  },
  activityLog: {
    title: 'History of activity'
  },
  input: {
    filter: 'Filter'
  },
  validation: {
    [DailyDiagramValidationReason.MISSING_PRODUCTION_PLAN_REVISION]:
      'For the device <DeviceName>{{deviceName}}</DeviceName>, there is a production plan revision that is not included in the daily diagram.',
    [DailyDiagramValidationReason.PRODUCTION_PLAN_REVISION_OUT_OF_DAILY_DIAGRAM]:
      'For the device <DeviceName>{{deviceName}}</DeviceName>, there is a newer revision of the production plan. Please update the daily diagram before proceeding.',
    [DailyDiagramValidationReason.PRODUCTION_PLAN_REVISION_IN_DRAFT_STATE]:
      'The revision of the daily diagram contains a production plan revision in progress for the device <DeviceName>{{deviceName}}</DeviceName>.',
    [DailyDiagramValidationReason.NEWER_REVISION_FOR_DRAFT_PRODUCTION_PLAN_REVISION_EXISTS]:
      'The daily diagram contains a production plan revision in progress for the device <DeviceName>{{deviceName}}</DeviceName>. There is a newer revision available for this device, please update the daily diagram.'
  }
};

export default enDispatcherProductionPlanning;
